import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-stat-grid',
  imports: [],
  templateUrl: './ui-stat-grid.component.html',
  styleUrl: './ui-stat-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiStatGridComponent {}
